export enum SRPLayoutEnum {
  MOSAIC = 'mosaic',
  FIXED = 'fixed',
}

export enum RefinementPanelStateEnum {
  OPEN = 'open',
  CLOSED = 'closed',
}
